export default __webpack_public_path__ + "static/media/kegs-empty.aca5b35e.png";